import { ChevronRight, Users, Award, Car, Briefcase } from 'lucide-react';
import { useState } from 'react';
import { Link } from 'react-router-dom';

function ServicesSection() {
  const [showMore, setShowMore] = useState(false);

  return (
    <section id="services" className="py-20 md:py-24 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <p className="eyebrow justify-center mb-3">What We Offer</p>
          <h2 className="section-title">
          <Link to="/services" className="hover:text-[#73BDF2] transition-colors duration-300">Explore our
            <br />
            services</Link>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Service 1 */}
          <div className="bg-black rounded-2xl overflow-hidden shadow-elevated transform hover:-translate-y-2 transition-transform duration-300 animate-fadeIn">
            <div className="livery-stripe" />
            <div className="p-8 text-white">
              <div className="bg-[#73BDF2]/15 w-16 h-16 rounded-full flex items-center justify-center mb-6">
                <Users size={30} className="text-[#73BDF2]" />
              </div>
              <h3 className="text-xl font-heading font-bold mb-4">
                Meet and Greet Service
              </h3>
              <p className="mb-8 text-white/60">
                Personalized welcome and assistance throughout your airport
                journey.
              </p>
              <Link to="/services">
              <button className="btn-outline-light">
                Read More <ChevronRight size={18} />
              </button>
              </Link>
            </div>
          </div>

          {/* Service 2 */}
          <div className="bg-gradient-to-br from-[#73BDF2] to-black rounded-2xl overflow-hidden shadow-elevated transform hover:-translate-y-2 transition-transform duration-300 animate-fadeIn delay-100">
            <div className="p-8 text-white">
              <div className="bg-white/20 w-16 h-16 rounded-full flex items-center justify-center mb-6">
                <Award size={30} className="text-white" />
              </div>
              <h3 className="text-xl font-heading font-bold mb-4">Lounge Services</h3>
              <p className="mb-8 text-white/80">
                Exclusive access to premium lounges for comfort and
                relaxation.
              </p>
              <Link to="/services">
              <button className="btn-white">
                Read More <ChevronRight size={18} />
              </button>
              </Link>
            </div>
          </div>

          {/* Service 3 */}
          <div className="bg-black rounded-2xl overflow-hidden shadow-elevated transform hover:-translate-y-2 transition-transform duration-300 animate-fadeIn delay-200">
            <div className="livery-stripe" />
            <div className="p-8 text-white">
              <div className="bg-[#73BDF2]/15 w-16 h-16 rounded-full flex items-center justify-center mb-6">
                <Car size={30} className="text-[#73BDF2]" />
              </div>
              <h3 className="text-xl font-heading font-bold mb-4">Fleet Services</h3>
              <p className="mb-8 text-white/60">
                Luxury chauffeur and transportation services for seamless
                travel.
              </p>
              <Link to="/services">
              <button className="btn-outline-light">
                Read More <ChevronRight size={18} />
              </button>
              </Link>
            </div>
          </div>
        </div>

        {showMore && (
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-8 animate-fadeIn">
            {/* Service 4 */}
            <div className="bg-gradient-to-br from-[#73BDF2] to-black rounded-2xl overflow-hidden shadow-elevated transform hover:-translate-y-2 transition-transform duration-300">
              <div className="p-8 text-white">
                <div className="bg-white/20 w-16 h-16 rounded-full flex items-center justify-center mb-6">
                  <Briefcase size={30} className="text-white" />
                </div>
                <h3 className="text-xl font-heading font-bold mb-4">Baggage Assistance</h3>
                <p className="mb-8 text-white/80">
                  Professional handling of your luggage from arrival to
                  departure.
                </p>
                <Link to="/services">
                <button className="btn-white">
                  Read More <ChevronRight size={18} />
                </button>
                </Link>
              </div>
            </div>
          </div>
        )}

        <div className="text-center mt-12">
          <button
            onClick={() => setShowMore(!showMore)}
            className="btn-outline"
          >
            {showMore ? 'Show less' : 'Show me more'}
          </button>
        </div>
      </div>
    </section>
  );
}

export default ServicesSection;
